<template>
    <div class="position-box">
        <div class="head">
            <img class="back" src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('xbsg.wdsg')}}</div>
        </div>
        <div class="cotainer subscriptionList">
            <ul class="ul-box">
              <li class="li"  v-for="(item, index) in list" :key="index">
                  <div class="li-head">
                      <div class="t1"><span>{{$t('xbsg.bz')}}</span> {{item.currency}}</div>
                      <div class="t2 active" v-if="item.status == 0">{{$t('xbsg.shz')}}</div>
                      <div class="t2" v-else-if="item.status == 1">{{$t('xbsg.ytg')}}</div>
                      <div class="t2" v-else>{{$t('xbsg.wtg')}}</div>
                  </div>
                  <div class="time"><span>{{$t('xbsg.sgrq')}}</span> {{item.buy_time_format}}</div>
                  <div class="item-box">
                      <div class="item">
                          <div class="t1">{{$t('xbsg.sgsl')}}</div>
                          <div class="t2">{{item.buy_amount}} {{item.currency}}</div>
                      </div>
                      <div class="item">
                          <div class="t1 center">{{$t('xbsg.tgsl')}}</div>
                          <div class="t2 center">{{item.true_amount}} {{item.currency}}</div>
                      </div>
                      <div class="item">
                          <div class="t1 text-right">{{$t('xbsg.ssrq')}}</div>
                          <div class="t2 text-right">{{item.start_time_format}}</div>
                      </div>
                  </div>
              </li>
            </ul>
            <!-- 暂无数据 -->
            <no-data v-show="isNoData"></no-data>
            <img id="goTop" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/top.png" alt="">
        </div>
    </div>
</template>

<script>
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
export default {
    name: 'subscriptionList',
    data () {
        return {
            isNoData: true,
            list: [],
            isGoTOP: false,
            curDataLength: 10,
            theme: false,
            page: 1,
            scrollbarObj: {
                fade: true
            },
             // 这个配置用于做下拉刷新功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启下拉刷新，可以配置顶部下拉的距离（threshold） 来决定刷新时机以及回弹停留的距离（stop）
            pullDownRefreshObj: {
                threshold: 90,
                stop: 40,
                txt: this.$t('tips.sxcg')
            },
            // 这个配置用于做上拉加载功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启上拉加载，可以配置离底部距离阈值（threshold）来决定开始加载的时机
            pullUpLoadObj: {
                threshold: 0,
                txt: {
                    more: this.$t('tips.jzgd'),
                    noMore: this.$t('tips.mygdsjl')
                }
            },
            startY: 0, // 纵轴方向初始化位置
            scrollToY: 0,
            scrollToTime: 500,
            isTop: false,
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {
      this.getMyNewcoins()
    },
    methods: {
       back(){
           this.$router.push('/subscription')
       },
        goTop(){
          $('.ul-box').animate({scrollTop:'0px'},'slow');
        },
        getMyNewcoins(){
          let params = {
            page: this.page
          }
          this.$ajax.get('/web/getMyNewcoins',{params}).then((res) => {
              let resData = res.data.data;
              if(res.data.code == 1000){
                // this.$toast.center(res.data.message);
                setTimeout(()=>{
                  this.$router.push('/index');
                },1000)
                return false
              }
              if(resData.length > 0){
                this.list = this.list.concat(resData);
                this.curDataLength = resData.length;
              }else{
                  this.curDataLength = resData.length;
              }
              if(this.list.length > 0){
                  this.isNoData = false;
              }else{
                  this.isNoData = true;
              }
            }).catch(function(err){
                console.log(err)
            })
       },
        listenScroll(e) {  //监听滚动
          let ele = e.srcElement ? e.srcElement : e.target;
          if(ele.scrollTop > 200){
              this.isGoTOP = true
          }else{
              this.isGoTOP = false
          }
          if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
              if(this.curDataLength > 0){
                  this.page ++;
                  this.getMyNewcoins();
              }
          }
        },
    },
    components:{
        noData,
        VueBetterScroll
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .position-box{
      position: absolute;
      left: 0;
      top: 0;
      bottom: 1.2rem;
      width: 100%;
      height: auto;
      color: #cecece;
      font-size: .36rem;
      background: url('../assets/element-background.png') no-repeat center center;
      background-size: cover;
      overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 1.2rem;
        padding: 0 .44rem;
        color: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .32rem;
        margin-top: -.3rem;
    }
    .head .title{
        font-size: .52rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.2rem;
        bottom: 0;
        width: 100%;
        overflow-y: scroll;
    }
    .ul-box .li{
      margin: .36rem .36rem 0;
      padding: .66rem .3rem;
      border-radius: .26rem;
      background: rgba(41,55,68,.2);
  }
  .ul-box .li .li-head{
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #fff;
      font-size: .36rem;
  }
  .ul-box .li .li-head .t2.active{
      color: #588bf8;
  }
  .ul-box .li .time{
      padding: .42rem 0;
      color: #8A8A8A;
      font-size: .36rem;
  }
  .ul-box .li .type-box .text{
      display: inline-block;
      margin-right: .24rem;
      padding: .12rem .42rem;
      font-size: .36rem;
      border-radius: .12rem;
  }
  .ul-box .li .type-box .t1{
      color: #123F7D;
      background: #DFEDFF;
  }
  .ul-box .li .type-box .t2{
      color: #fff;
      background: #FA0000;
  }
  .ul-box .li .item-box{
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      margin-top: .3rem;
  }
  .ul-box .li .item-box .item .t1{
      color: #8A8A8A;
      font-size: .36rem;
  }
  .ul-box .li .item-box .item .t2{
      padding-top: 10px;
      color: #000;
      font-size: .36rem;
  }
  .ul-box .li .item-box .item .center{
      text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/subscriptionList.vue